import debounce from 'lodash-es/debounce';
import {
  MutableRefObject,
  useEffect,
  useState,
} from 'react';
import resizeMeasurementListener, {
  IListener,
} from '../ResizeMeasurementListener';

export interface Size {
  width: number;
  height: number;
}

interface IInput {
  elemRef: MutableRefObject<HTMLElement | null>;
}
export default (input: IInput) => {
  const [size, setSize] = useState<Size | undefined>(undefined);
  const {elemRef} = input;

  const roundAndSetSize = debounce((inputSize: Size) => setSize({
    width: Math.floor(inputSize.width),
    height: Math.floor(inputSize.height),
  }), 500);

  const getResizeListener = (ref: typeof elemRef): IListener => {
    let decimalWidth: number;
    let decimalHeight: number;
    let originalPositioning: string;

    const before = () => {
      const target = ref.current;
      if (target !== null) {
        // Remember the original value of `position` and `height` so that we can restore them later:
        const computedStyle = window.getComputedStyle(target);
        originalPositioning = computedStyle.position!;
        if (originalPositioning !== null) {
          // ... then take the graph's root elemen out of the flow by setting its `position`
          // to `absolute`. This allows the element to resize to is "natural"
          // width...
          target.style.position = 'absolute';
        }
      }
    };

    const measure = () => {
      const target = ref.current;
      if (target !== null) {
        // ... which we measure (excluding the height)...
        const {width, height} = target.getBoundingClientRect();
        decimalWidth = width;
        decimalHeight = height;

      }
    };

    const after = () => {
      const target = ref.current;
      if (target !== null) {
        // ... then restore the `position` and `height` to their original values:
        target.style.position = originalPositioning;
      }

      roundAndSetSize({width: decimalWidth, height: decimalHeight});
    };

    return {
      before,
      measure,
      after,
    };
  };

  useEffect(() => {
    const elem = elemRef.current;
    if (elem !== null) {
      const {width, height} = elem.getBoundingClientRect();
      roundAndSetSize({width, height});

      const listener = getResizeListener(elemRef);
      resizeMeasurementListener.addListener(listener);
      return () => resizeMeasurementListener.removeListener(listener);
    }
  }, []);
  return {size};
};
